import { useState, useEffect } from 'react';
import AuthShell from './AuthShell';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Label } from '../ui/label';

const LoginScreen = ({ onLogin, api, onNav }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState('');
  const [unverified, setUnverified] = useState(false);
  const [resent, setResent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem('swolepump_email');
    if (saved) { setEmail(saved); setRememberMe(true); }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setUnverified(false); setResent(false); setIsLoading(true);
    try {
      const res = await api.post('/auth/login', { email, password });
      if (rememberMe) localStorage.setItem('swolepump_email', email);
      else localStorage.removeItem('swolepump_email');
      onLogin(res.user, res.token);
    } catch (err) {
      if (err.code === 'unverified') {
        setUnverified(true);
        setError('Your email isn’t verified yet.');
      } else {
        setError('Invalid email or password');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const resendVerification = async () => {
    try {
      await api.post('/auth/resend-verification', { email });
      setResent(true);
    } catch {
      setResent(true); // generic response either way
    }
  };

  return (
    <AuthShell
      title="Sign in"
      footer={<>New here? <button onClick={() => onNav('register')} className="text-primary hover:underline">Create an account</button></>}
    >
      <form onSubmit={handleSubmit} className="space-y-5">
        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} required autoFocus />
        </div>
        <div className="space-y-2">
          <Label htmlFor="password">Password</Label>
          <Input id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} required />
        </div>
        <div className="flex items-center justify-between">
          <label className="flex items-center gap-2 text-sm">
            <input type="checkbox" checked={rememberMe} onChange={e => setRememberMe(e.target.checked)} className="rounded border-input" />
            Remember my email
          </label>
          <button type="button" onClick={() => onNav('forgot')} className="text-sm text-primary hover:underline">
            Forgot password?
          </button>
        </div>
        {error && (
          <div className="text-sm text-destructive bg-destructive/10 p-3 rounded-md text-center">
            {error}
            {unverified && !resent && (
              <> <button type="button" onClick={resendVerification} className="underline font-medium">Resend link</button></>
            )}
            {resent && <div className="text-muted-foreground mt-1">Verification email sent.</div>}
          </div>
        )}
        <Button type="submit" disabled={isLoading} className="w-full">
          {isLoading ? 'Signing in…' : 'Sign in'}
        </Button>
      </form>
    </AuthShell>
  );
};

export default LoginScreen;
